if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
/**
 *  @class
 *  @function ThemeHeader
 */

if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.header_section = document.querySelector('.header-section');
      this.menu = this.querySelector('#mobile-menu');
      this.toggle = this.querySelector('.mobile-toggle-wrapper');

      document.addEventListener('keyup', (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === 'ESCAPE') {
            this.toggle.removeAttribute('open');
            this.toggle.classList.remove('active');
          }
        }
      });
      if (this.classList.contains('header-sticky--active')) {
        document.body.classList.add('header-sticky--active');
      }
      this.toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
        if (this.toggle.classList.contains('active')) {
          e.preventDefault();
          document.body.classList.remove('overflow-hidden');
          this.toggle.classList.remove('active');
          this.closeAnimation(this.toggle);
        } else {
          document.body.classList.add('overflow-hidden');
          setTimeout(() => {
            this.toggle.classList.add('active');
          });
        }
      });

      // Sticky Header Class
      window.addEventListener('scroll', this.setStickyClass.bind(this), {
        passive: true
      });

      // Mobile Menu offset
      window.addEventListener('scroll', this.setHeaderOffset.bind(this), {
        passive: true
      });
      window.addEventListener('scroll', this.setHeaderHeight.bind(this), {
        passive: true
      });

      window.dispatchEvent(new Event('scroll'));

      if (document.querySelector('.announcement-bar-section')) {

        window.addEventListener('scroll', this.setAnnouncementHeight(), {
          passive: true
        });
        window.dispatchEvent(new Event('resize'));
      }

      // Mobile Navigation transparent header support.
      setTimeout(() => {

        this.mobile_nav = document.querySelector('.header-mobile-navigation');

        if (this.mobile_nav && this.classList.contains('transparent--true')) {
          this.mobile_nav.classList.add('is-fixed');
        }
      }, 100);
      // Buttons.
      this.menu.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
      this.menu.querySelectorAll('.parent-link-back--button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }
    setStickyClass() {
      if (this.classList.contains('header-sticky--active')) {
        let offset = parseInt(this.getBoundingClientRect().top, 10) + document.documentElement.scrollTop;
        this.classList.toggle('is-sticky', window.scrollY >= offset && window.scrollY > 0);
        // Kompakter Desktop-Header (custom-critical.css) mit Hysterese: Das
        // Schrumpfen verkuerzt die Seite um ~46 px und verschiebt die
        // Scrollposition. Mit nur einer Schwelle schaltete der Header nahe
        // oben deshalb staendig hin und her.
        if (window.scrollY > 200) {
          this.classList.add('is-compact');
        } else if (window.scrollY < 60) {
          this.classList.remove('is-compact');
        }
      }
    }
    setAnnouncementHeight() {
      const a_bar = document.querySelector('.announcement-bar-section');
      let h = a_bar.clientHeight;
      document.documentElement.style.setProperty('--announcement-height', h + 'px');
    }
    setHeaderOffset() {
      let h = this.header_section.getBoundingClientRect().top;
      document.documentElement.style.setProperty('--header-offset', h + 'px');
    }
    setHeaderHeight() {
      let h = this.clientHeight;
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest('.link-container');
      const isOpen = detailsElement.hasAttribute('open');
      if (this.querySelector('.parent-link-back--button')) {
        this.menu.scrollTop = 0;
      }
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
      }, 100);
    }
    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
      detailsElement.classList.remove('menu-opening');
      this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
  }
  customElements.define('theme-header', ThemeHeader);
}

/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();

      this.submenus = this.querySelectorAll('.thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu');
    }
    connectedCallback() {
      this.setupMegaMenuProducts();
      this.setupDropdownA11y();
      if (!this.submenus.length) {
        return;
      }
      const _this = this;
      // resize on initial load
      document.fonts.ready.then(function() {
        window.addEventListener('resize', debounce(function() {
          _this.resizeSubMenus();
        }, 100));
      });

    }
    setupMegaMenuProducts() {
      const placeholders = this.querySelectorAll('.megamenu-products-placeholder[data-megamenu-collection]');
      placeholders.forEach((placeholder) => {
        const item = placeholder.closest('.menu-item-has-megamenu');
        if (!item) {
          return;
        }
        let loaded = false;
        const load = () => {
          if (loaded) {
            return;
          }
          loaded = true;
          const handle = placeholder.getAttribute('data-megamenu-collection');
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          fetch(`${root}collections/${handle}?section_id=mega-menu-products`)
            .then((response) => (response.ok ? response.text() : Promise.reject(response.status)))
            .then((html) => {
              const fragment = new DOMParser().parseFromString(html, 'text/html');
              const columns = fragment.querySelectorAll('.megamenu-product-col');
              if (!columns.length) {
                return;
              }
              columns.forEach((column) => placeholder.parentNode.insertBefore(column, placeholder));
              placeholder.remove();
              if (window.lazySizes && window.lazySizes.loader) {
                window.lazySizes.loader.checkElems();
              }
            })
            .catch(() => {
              loaded = false;
            });
        };
        item.addEventListener('mouseenter', load);
        item.addEventListener('focusin', load);
        item.addEventListener('touchstart', load, { passive: true });
      });
    }
    // Dropdowns oeffnen per CSS (:hover, :focus-within). Hier nur aria-expanded
    // fuer Screenreader nachfuehren und Escape zum Schliessen: .is-closed
    // blendet das Dropdown aus, obwohl der Fokus noch auf dem Menuepunkt steht.
    setupDropdownA11y() {
      const items = this.querySelectorAll('.thb-full-menu > li.menu-item-has-children');
      // Escape schliesst auch ein per Maus geoeffnetes Dropdown (Fokus woanders).
      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') {
          return;
        }
        items.forEach((item) => {
          if (item.matches(':hover') && !item.contains(document.activeElement)) {
            item.classList.add('is-closed');
            item.querySelector(':scope > a')?.setAttribute('aria-expanded', 'false');
          }
        });
      });
      items.forEach((item) => {
        const link = item.querySelector(':scope > a');
        if (!link) {
          return;
        }
        const setOpen = (open) => {
          link.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (open) {
            item.classList.remove('is-closed');
          }
        };
        item.addEventListener('mouseenter', () => setOpen(true));
        item.addEventListener('mouseleave', () => {
          if (item.contains(document.activeElement)) {
            // Tastaturfokus bleibt: offen, ausser Escape hat geschlossen
            link.setAttribute('aria-expanded', item.classList.contains('is-closed') ? 'false' : 'true');
          } else {
            item.classList.remove('is-closed');
            link.setAttribute('aria-expanded', 'false');
          }
        });
        item.addEventListener('focusin', () => {
          if (!item.classList.contains('is-closed')) {
            setOpen(true);
          }
        });
        item.addEventListener('focusout', (e) => {
          if (!item.contains(e.relatedTarget)) {
            item.classList.remove('is-closed');
            setOpen(item.matches(':hover'));
          }
        });
        item.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && link.getAttribute('aria-expanded') === 'true') {
            item.classList.add('is-closed');
            link.setAttribute('aria-expanded', 'false');
            link.focus();
          } else if (e.key === 'ArrowDown' && e.target === link && item.classList.contains('is-closed')) {
            e.preventDefault();
            setOpen(true);
          }
        });
      });
    }
    resizeSubMenus() {
      const viewportWidth = window.innerWidth;
      const updates = [];

      // Read phase: gather all measurements first so we never read a layout
      // property right after writing one (which forces a synchronous reflow).
      this.submenus.forEach((submenu) => {
        const sub_submenus = submenu.querySelectorAll(':scope >.menu-item-has-children>.sub-menu');
        sub_submenus.forEach((sub_submenu) => {
          const parent = sub_submenu.parentElement;
          const total = sub_submenu.offsetWidth + parent.getBoundingClientRect().left + parent.offsetWidth;
          updates.push({ parent: parent, overflow: total > viewportWidth });
        });
      });

      // Write phase: apply all class changes after every measurement is done.
      updates.forEach((update) => {
        update.parent.classList.toggle('left-submenu', update.overflow);
      });
    }
  }
  customElements.define('full-menu', FullMenu);
}
window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.expand = 250;
window.lazySizesConfig.loadMode = 1;
window.lazySizesConfig.loadHidden = false;